import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import { Container, Typo, Buttons, HR } from 'tmt-ui-kit';

import HeadTag from '~/components/Head/HeadTag';
import Link from '~/components/Link/Link';
import LazyLoadImage from '~/components/Image/LazyLoadImage';

import config from '~/config';

import BannerHelp from '~/components/HelpCenter/BannerHelp';

const HomeContainer = styled.div`
  margin-bottom: 32px;
`;

const ContentContainer = styled.div`
  margin-top: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;
  div {
    >p {
      margin:12px auto 16px;
    }
  }
`;
const Title = styled(Typo.HeaderTwo)`
  margin: 0px;
`;
const Text = styled(Typo.Paragraph)`
  width: ${props => (props.bottom ? '80%' : '95%')};
`;
const Upsell = styled.div`
  width: 60%;
  margin: 0 auto;
  @media(max-width: 800px) {
    width: 80%;
  }
  @media(max-width: 600px) {
    width: 100%;
  }
`;
const Content = styled.div`
  display: flex;
  justify-content: space-around;
  @media(max-width: 600px) {
    flex-direction: column;
  }
`;
const ItemContainer = styled.div`
  text-align: center;
  color: ${props => props.theme.darkBlueTwo} !important;
`;
const DescriptionIcon = styled(Typo.Paragraph)`
  font-size: 18px !important;
  font-weight: 500 !important;
  text-align: center;
  width: 152px;
  margin: auto;
`;
const AnswersButton = styled(Buttons.Button.WhiteButton)`
  width: 160px;
  height: 32px;
  font-weight: 500;
  padding: 0;
  margin-top: 28px;
`;
const Image = styled(LazyLoadImage)`
  display: block;
  width: 99px;
  height: 99px;
  margin: 15px auto;
`;
const VerticalHR = styled.div`
  display: block;
  width: 1px;
  background: ${props => props.theme.blueGray} !important;
  @media(max-width: 600px) {
    width: 100%;
    height: 1px;
    margin: 25px auto;
  }
`;

class HomeCenter extends Component {
  render() {
    return (
      <Fragment>
        <HeadTag
          title="Help Center - TakeMeTour"
        />
        <HomeContainer>
          <BannerHelp />
          <Container.InnerContainer>
            <ContentContainer>
              <Title>Everything you need to know so you can use TakeMeTour</Title>
              <Text>Welcome to Thailand! At TakeMeTour, we specialize in one-day tours of the sights, attractions, and best-kept secrets of Thailand. Each tour is led by a Local Expert, who can answer all your questions as well as introduce you to the hotspots you may miss on another tour. </Text>
            </ContentContainer>
            <HR />
            <Upsell>
              <Content>
                <Link to="/help-center/traveler">
                  <ItemContainer>
                    <DescriptionIcon>Traveler Help Center</DescriptionIcon>
                    <AnswersButton>Find Your Answers</AnswersButton>
                    <Image
                      data-src={`${config.assetPath}/static/images/HelpCenter/fill-2@2x.png`}
                      data-srcset={`${config.assetPath}/static/images/HelpCenter/fill-2@2x.png`}
                      // className="image"
                      alt="Attraction Tickets"
                    />
                  </ItemContainer>
                </Link>
                <VerticalHR />
                <Link to="/help-center/local-expert">
                  <ItemContainer>
                    <DescriptionIcon>Essential for Local Expert</DescriptionIcon>
                    <AnswersButton>Find Your Answers</AnswersButton>
                    <Image
                      data-src={`${config.assetPath}/static/images/HelpCenter/fill-1@2x.png`}
                      data-srcset={`${config.assetPath}/static/images/HelpCenter/fill-1@2x.png`}
                      // className="image"
                      alt="Attraction Tickets"
                    />
                  </ItemContainer>
                </Link>
              </Content>
            </Upsell>
          </Container.InnerContainer>
        </HomeContainer>
      </Fragment>
    );
  }
}

export default HomeCenter;
